import {
	Box,
	Button,
	Icons,
	Inline,
	Stack,
	Text,
} from "@sembark-travel/ui-base"
import {
	CopyToClipboard,
	CopyToClipboardButton,
} from "@sembark-travel/ui-copy-to-clipboard"
import { useState } from "react"

/**
 * A read-only value with a copy button, used for the webhook credentials we
 * hand over to an external platform.
 */
export function CopyableValue({
	label,
	value,
	secret = false,
}: {
	label: string
	value: string
	/** hide the value behind a toggle, for credentials */
	secret?: boolean
}) {
	const [revealed, setRevealed] = useState(false)
	const hidden = secret && !revealed
	return (
		<CopyToClipboard>
			{({ copyTextToClipboard }) => (
				<Stack gap="1">
					<Text fontWeight="semibold">{label}</Text>
					<Inline
						gap="2"
						alignItems="center"
						paddingY="1"
						paddingLeft="4"
						paddingRight="1"
						borderWidth="1"
						rounded="md"
						bgColor="subtle"
					>
						{/* copy the value itself, so a hidden secret still copy in full */}
						<Box>{hidden ? "•".repeat(16) : value}</Box>
						{secret ? (
							<Button
								size="sm"
								title={revealed ? "Hide" : "Show"}
								onClick={() => setRevealed((shown) => !shown)}
							>
								{revealed ? <Icons.EyeSlash /> : <Icons.Eye />}
							</Button>
						) : null}
						<CopyToClipboardButton
							size="sm"
							onClick={async () => {
								return copyTextToClipboard(value)
							}}
						>
							<Icons.Duplicate />
						</CopyToClipboardButton>
					</Inline>
				</Stack>
			)}
		</CopyToClipboard>
	)
}
